import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { LifemapQuestionsComponent } from '@app/components/blocks/block-lifemap/lifemapQuestions/lifemapQuestions.component';
import { SwiperDirective } from '@shared/directives/carousel.directive';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import { SingleQuestionModule } from '@app/components/blocks/block-lifemap/lifemapQuestions/singleQuestion/singleQuestion.module';
import { FormsModule } from '@angular/forms';

// register Swiper custom elements
register();

@NgModule({
  imports: [CommonModule, PlIconModule, SwiperDirective, SharedModule, SingleQuestionModule, FormsModule],
  declarations: [LifemapQuestionsComponent],
  exports: [LifemapQuestionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LifemapQuestionsModule {}
